import styled from 'styled-components';

import {
  SkeletonBodyCopy,
  SkeletonButton as BaseSkeletonButton,
  SkeletonCard,
  SkeletonHeadline,
} from '@xing-com/skeleton';
import { spaceS, spaceXL } from '@xing-com/tokens';

const SkeletonWrapper = styled(SkeletonCard)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
`;

const SkeletonButton = styled(BaseSkeletonButton)`
  margin-top: ${spaceXL};
`;

export const ExperimentalMatchingSkillsSkeleton: React.FC = () => (
  <SkeletonWrapper>
    <SkeletonHeadline amountRows={1} sizeConfined="medium" />
    <SkeletonBodyCopy amountRows={3} />
    <SkeletonButton />
  </SkeletonWrapper>
);
